import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from '../components/Appbar'
import Helmet from 'react-helmet';
import DropZone from './Dropzone';
import DraggableImageList from './DragableImageList';
import { useSnackbar } from 'notistack';
import DisplayAxiosError from '../util/DisplayAxiosError';

export type Image = {
    url: string;
    loading: boolean;
}

type propTypes = {
    imageURLs: string[],
    max: number,
    uploadEndpoint: string,
    accept?: string,
    uploadField: string,
    onReorder?: (images: Image[]) => void,
    removeImage: (URL: string) => void;
    uploadFinishedCB? : (urls: string[]) => void;
}

const ImageUploader = (props: propTypes) => {
    const accept = props.accept || 'image/png, image/jpeg, image/jpg, image/webp';
    const [images, setImages] = useState([]);
    const imageRef = useRef(images);
    imageRef.current = images;

    //init snackbar
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    //init images from urls
    useEffect(() => {
        setImages(props.imageURLs.map(url => ({ url: `https://static.poly.pizza/${url}`, loading: false })))
    }, []);

    //set url for image at i
    function AddNewImageAtIndex(image: Image, i: number) {
        const newImages = [...imageRef.current];
        newImages[i] = image;
        setImages(newImages);
    }

    const handleFilePick = async (files: File[]) => {
        let filesLeft = 5 - props.imageURLs.length;        

        if(filesLeft <= 0) {
            enqueueSnackbar('You can only upload 5 images', { variant: 'error' });
            return; 
        }

        const filesAllowed = Math.min(filesLeft, files.length);
        
        let fd = new FormData();
        const index = imageRef.current.length;
        for (let i = 0; i < filesAllowed; i++) {
            const f = files[i];
            let reader = new FileReader();            
            reader.onload = (function (theFile) {
                return function (e) {
                    AddNewImageAtIndex({ url: e.target?.result, loading: true }, index + i);
                };
            })(f);
            reader.readAsDataURL(f);

            fd.append(props.uploadField, f, f.name);
        }

        axios.post(props.uploadEndpoint, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((res) => {
            //set the image at i to the new URL and turn off loading
            for (let i = 0; i < res.data.urls.length; i++) {
                const url = res.data.urls[i];
                AddNewImageAtIndex({ url, loading: false }, index + i);
            }
            if(props?.uploadFinishedCB) props.uploadFinishedCB(res.data.urls);
            
        }).catch((error) => {
            console.log(error)
            DisplayAxiosError(error, enqueueSnackbar)
            //delete the last image in the array
            setImages(imageRef.current.slice(0, -1));
        });

    };

    return (
        <React.Fragment>
            <form id="uploadForm" encType="multipart/form-data" className="pb-2">
                <div className="w-full border-5 border-dotted border-orange-main">
                    <DropZone
                        accept={accept}
                        zoneStyle={{ height: '15vh' }}
                        setFiles={handleFilePick}
                        maxFiles={props.max}
                        uploadText={'Drag images here or click to select files'}
                    />
                </div>
            </form>
            <DraggableImageList
                images={images}
                setImages={setImages}
                RemoveImage={props.removeImage}
                onDrag={props.onReorder}
            />
        </React.Fragment>
    );
}

export default ImageUploader;